let isInitAjaxFileDownload = false;

window.initAjaxFileDownload = function() {

  if (!isInitAjaxFileDownload) {
    $("[id^=form-download-export]").submit(function() {
      $('#error-message').hide().empty();
      lockUIForDownload($('.btn-start-download'));
    });

    function lockUI(buttonDl) {
      buttonDl.button('loading');
    }

    function unLockUI(buttonDl) {
      buttonDl.button('reset');
    }

    function downloadStarted(buttonDl) {
      window.clearInterval(fileDownloadCheckTimer);
      Cookies.remove('fileDownloadToken'); //clears this cookie value
      $('.download-token').val(null);
      unLockUI(buttonDl);
    }

    let fileDownloadCheckTimer;

    function lockUIForDownload(buttonDl) {
      let token = new Date().getTime().toString(); //use the current timestamp as the token value
      $('.download-token').val(token);

      lockUI(buttonDl);

      fileDownloadCheckTimer = window.setInterval(function() {
        let cookieValue = Cookies.get('fileDownloadToken');

        if (cookieValue === token) {
          downloadStarted(buttonDl);
        }
      }, 500);
    }
  }
  isInitAjaxFileDownload = true;

}
